import React, { FC, PropsWithChildren } from 'react';
import { Td, Text } from '@chakra-ui/react';

const LCell: FC<PropsWithChildren> = ({ children }) => (
  <Td>
    <Text fontSize='sm'>
      {children}
    </Text>
  </Td>
);

export default LCell;
